class GnlYetkitanimDTO {
    id?: number = null;
    fkGnlModulId?: number = null;
    treekey?: string = null;
    yetkikodu?: string = null;
    yetkiadi?: string = null;
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    bagliId?: number = null;
    seviye?: number = null;
    tipi?: number = null;
}
export default GnlYetkitanimDTO;